export default () => ({
  component: 'packages-type-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
